export type Elevation = Record<'tiny' | 'small' | 'medium', Readonly<{ boxShadow: string }>>;

export const elevation: Elevation = {
  tiny: {
    boxShadow: '0px 0px 4px rgba(0, 0, 0, .2)',
  },
  small: {
    boxShadow: '0px 0px 8px rgba(0, 0, 0, .15)',
  },
  medium: {
    boxShadow: '0px 0px 20px rgba(0, 0, 0, .12)',
  },
};
